/**
 * Engagement Module
 * Handles reading achievements, emoji reactions, confetti
 */

function initReadingAchievements() {
    const postBody = document.getElementById('post-body');
    if (!postBody) return;
    
    const isEnglish = document.documentElement.lang === 'en';
    
    const achievements = isEnglish ? [
        { percent: 25, emoji: '☕', title: '25% done!', subtitle: 'Keep going!' },
        { percent: 50, emoji: '🚀', title: '50% done!', subtitle: 'You\'re on track!' },
        { percent: 75, emoji: '🔥', title: '75% done!', subtitle: 'Almost there!' },
        { percent: 100, emoji: '🎉', title: '100% done!', subtitle: 'You\'re a champion!', confetti: true }
    ] : [
        { percent: 25, emoji: '☕', title: '25% geschafft!', subtitle: 'Weiter so!' },
        { percent: 50, emoji: '🚀', title: '50% geschafft!', subtitle: 'Du bist auf Kurs!' },
        { percent: 75, emoji: '🔥', title: '75% geschafft!', subtitle: 'Fast da!' },
        { percent: 100, emoji: '🎉', title: '100% geschafft!', subtitle: 'Du bist ein Champion!', confetti: true }
    ];
    
    const shown = new Set();
    
    function checkAchievements() {
        const postBodyTop = postBody.offsetTop;
        const postBodyHeight = postBody.offsetHeight;
        const windowHeight = window.innerHeight;
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const scrollIntoPost = scrollTop - postBodyTop;
        const scrollableHeight = postBodyHeight - windowHeight;
        const scrollPercentage = Math.max(0, Math.min((scrollIntoPost / scrollableHeight) * 100, 100));
        
        achievements.forEach(achievement => {
            if (scrollPercentage >= achievement.percent && !shown.has(achievement.percent)) {
                showAchievement(achievement);
                shown.add(achievement.percent);
                
                if (achievement.confetti) {
                    setTimeout(() => triggerConfetti(), 300);
                }
            }
        });
    }
    
    let ticking = false;
    window.addEventListener('scroll', () => {
        if (ticking) return;
        
        window.requestAnimationFrame(() => {
            checkAchievements();
            ticking = false;
        });
        ticking = true;
    });
}

function showAchievement(achievement) {
    const toast = document.getElementById('achievement-toast');
    if (!toast) return;
    
    const emoji = document.getElementById('achievement-emoji');
    const title = document.getElementById('achievement-title');
    const subtitle = document.getElementById('achievement-subtitle');
    
    emoji.textContent = achievement.emoji;
    title.textContent = achievement.title;
    subtitle.textContent = achievement.subtitle;
    
    toast.classList.remove('opacity-0', 'translate-x-full');
    toast.classList.add('opacity-100', 'translate-x-0');
    
    setTimeout(() => {
        toast.classList.remove('opacity-100', 'translate-x-0');
        toast.classList.add('opacity-0', 'translate-x-full');
    }, 3000);
}

function triggerConfetti() {
    const canvas = document.getElementById('confetti-canvas');
    if (!canvas) return;
    
    canvas.style.display = 'block';
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    
    const ctx = canvas.getContext('2d');
    const confetti = [];
    const confettiCount = 150;
    const colors = ['#ff0000', '#00ff00', '#0000ff', '#ffff00', '#ff00ff', '#00ffff', '#ffa500', '#ff69b4'];
    
    for (let i = 0; i < confettiCount; i++) {
        confetti.push({
            x: Math.random() * canvas.width,
            y: Math.random() * canvas.height - canvas.height,
            r: Math.random() * 6 + 2,
            d: Math.random() * confettiCount,
            color: colors[Math.floor(Math.random() * colors.length)],
            tilt: Math.random() * 10 - 10,
            tiltAngleIncremental: Math.random() * 0.07 + 0.05,
            tiltAngle: 0
        });
    }
    
    let animationId;
    function draw() {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        
        confetti.forEach((c, index) => {
            ctx.beginPath();
            ctx.lineWidth = c.r / 2;
            ctx.strokeStyle = c.color;
            ctx.moveTo(c.x + c.tilt + c.r, c.y);
            ctx.lineTo(c.x + c.tilt, c.y + c.tilt + c.r);
            ctx.stroke();
            
            c.tiltAngle += c.tiltAngleIncremental;
            c.y += (Math.cos(c.d) + 3 + c.r / 2) / 2;
            c.tilt = Math.sin(c.tiltAngle - c.d / 3) * 15;
            
            if (c.y > canvas.height) {
                confetti.splice(index, 1);
            }
        });
        
        if (confetti.length > 0) {
            animationId = requestAnimationFrame(draw);
        } else {
            canvas.style.display = 'none';
            cancelAnimationFrame(animationId);
        }
    }
    
    draw();
}

function initEmojiReactions() {
    const reactionBtns = document.querySelectorAll('.reaction-btn');
    if (reactionBtns.length === 0) return;
    
    const postUrl = window.location.pathname;
    const storageKey = `reactions_${postUrl}`;
    const userReactionsKey = `user_reactions_${postUrl}`;
    
    const reactions = JSON.parse(localStorage.getItem(storageKey) || '{}');
    const userReactions = JSON.parse(localStorage.getItem(userReactionsKey) || '[]');
    
    reactionBtns.forEach(btn => {
        const reaction = btn.dataset.reaction;
        const count = reactions[reaction] || 0;
        const countSpan = btn.querySelector('.reaction-count');
        countSpan.textContent = count;
        
        if (userReactions.includes(reaction)) {
            btn.classList.add('opacity-50');
        }
    });
    
    reactionBtns.forEach(btn => {
        btn.addEventListener('click', function() {
            const reaction = this.dataset.reaction;
            
            if (!userReactions.includes(reaction)) {
                reactions[reaction] = (reactions[reaction] || 0) + 1;
                userReactions.push(reaction);
                
                localStorage.setItem(storageKey, JSON.stringify(reactions));
                localStorage.setItem(userReactionsKey, JSON.stringify(userReactions));
                
                const countSpan = this.querySelector('.reaction-count');
                countSpan.textContent = reactions[reaction];
                this.classList.add('opacity-50');
                
                const emoji = this.querySelector('span:first-child');
                emoji.style.transform = 'scale(1.5)';
                setTimeout(() => emoji.style.transform = 'scale(1)', 200);
            }
        });
    });
}

function initParallax() {
    const parallaxImages = document.querySelectorAll('.parallax-image');
    if (parallaxImages.length === 0) return;
    
    let ticking = false;
    
    function updateParallax() {
        parallaxImages.forEach(img => {
            const container = img.closest('.parallax-container');
            if (!container) return;
            
            const rect = container.getBoundingClientRect();
            const scrollPercent = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
            const yPos = -(scrollPercent * 100 - 50) * 0.5;
            
            img.style.transform = `translateY(${yPos}px)`;
        });
    }
    
    window.addEventListener('scroll', () => {
        if (ticking) return;
        
        window.requestAnimationFrame(() => {
            updateParallax();
            ticking = false;
        });
        ticking = true;
    });
    
    updateParallax();
}
